import { IDatabase } from '../types/IDatabase';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IMaxDownstreamDatasources, IMaxDownstreamWorkbooks} from '../types/IMaxDownstreamConnections';

export interface IGetDatabasesParams extends IGetItemsParams {
}

export interface IGetDatabasesResult extends IGetItemsResult {
  databases?: IDatabase[];
  maxDownstreamDatasourcesViewModel?: IMaxDownstreamDatasources;
  maxDownstreamWorkbooksViewModel?: IMaxDownstreamWorkbooks;
}

export class GetDatabasesRequest extends Request<IGetDatabasesParams, IGetDatabasesResult> {
  constructor(params: IGetDatabasesParams) {
    super('getDatabases', params);
  }
}